import React, {useState, useEffect} from 'react';
import * as C from '../../Common.styles';
import * as S from './SupportingDocument.styles';
import {validations} from '../../../../../utils/validations';
import {UploadKycDoc, UploadFacadeDoc} from '../../../UI/UploadBlock/UploadFile';
import UploadInfo from '../../UI/UploadInfo/UploadInfo';
import UploadReset from '../../UI/UploadInfo/UploadReset';
import ButtonLoader from '../../../UI/Loader/Loader';
import {sendEvarData} from '@ibibo/analytics';
import {useAnalyticService} from '@ibibo/analytics-provider';

const SupportingDocument = ({
  data,
  error,
  status,
  submitDetails,
  uploadKYC,
  uploadFacade,
  kycDocList,
  setLoader,
  addDocList,
  disableSubmitButton,
}) => {
  const [{kycDocType, kycUploaded, facadeUploaded, additionalDoc}, setDocumentDetails] = useState({
    kycDocType: data.kycDocType || '',
    kycUploaded: data.kycUploaded || '',
    facadeUploaded: data.facadeUploaded || '',
    additionalDoc: data.additionalDoc || '',
  });

  const [apiErrorMsg, setApiError] = useState(error);
  const [errors, setError] = useState({});
  const [fileUrl, setFileUrl] = useState('');
  const [popKycVisible, setPopKycVisible] = useState(false);
  const [popFacadeVisible, setPopFacadeVisible] = useState(false);
  const [showClose, setShowClose] = useState(false);
  const {sendTrackingDataToSdk} = useAnalyticService();
  useEffect(() => {
    setApiError(error);
  }, [error]);

  useEffect(() => {
    setDocumentDetails({
      kycDocType: data.kycDocType || kycDocType,
      kycUploaded: data.kycUploaded || kycUploaded,
      facadeUploaded: data.facadeUploaded || facadeUploaded,
      additionalDoc: data.additionalDoc || additionalDoc,
    });
  }, [data]);

  const fieldValidators = {
    kycDocType: {fieldName: 'KYC Document Type', validators: ['required']},
    kycDoc: {fieldName: 'KYC Document', validators: ['required']},
    facadeDoc: {fieldName: 'Additional KYC Document', validators: addDocList ? ['required'] : ''},
    additionalDoc: {
      fieldName: 'Additional KYC Document Type',
      validators: addDocList ? ['required'] : '',
    },
  };

  const [
    {kycfileSize, kycfileName, kycsizeError, kycfileSuccess, kycupload},
    setKycFileInfo,
  ] = useState({
    kycfileSize: 0,
    kycfileName: '',
    kycsizeError: null,
    kycfileSuccess: true,
    kycupload: false,
  });

  const [
    {facadefileSize, facadefileName, facadesizeError, facadefileSuccess, facadeupload},
    setFacadeFileInfo,
  ] = useState({
    facadefileSize: 0,
    facadefileName: '',
    facadesizeError: null,
    facadefileSuccess: true,
    facadeupload: false,
  });

  const validateFields = data => {
    let errorObj = {};
    // fieldValidators.kycDocType.validators.push('required');
    // fieldValidators.kycDoc.validators.push('required');
    // fieldValidators.facadeDoc.validators.push('required');
    // fieldValidators.additionalDoc.validators.push('required');
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const resp = validateFunction({
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
          });
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  };

  const showKycUpload = () => {
    if (!popKycVisible) {
      const urlShow = URL.createObjectURL(document.getElementById('uploadKYCDoc').files[0]);
      setFileUrl(urlShow);
      setPopKycVisible(true);
    }
  };

  const showFacadeUpload = () => {
    if (!popFacadeVisible) {
      const urlShow = URL.createObjectURL(document.getElementById('uploadFacadeDoc').files[0]);
      setFileUrl(urlShow);
      setPopFacadeVisible(true);
    }
  };

  const uploadDocument = () => {
    if (!kycDocType) {
      errors['kycDocType'] = 'Required';
      setError(errors);
      return;
    }
    let kycFile = document.getElementById('uploadKYCDoc').files[0];
    const kycFileSize = kycFile.size / 1024 / 1024;
    if (kycFileSize < 5) {
      setKycFileInfo({
        kycfileSize: kycFileSize,
        kycfileName: kycFile.name,
        kycsizeError: null,
        kycfileSuccess: false,
        kycupload: false,
      });
      uploadKYC({kycFile, kycDocType});
    } else {
      setKycFileInfo({
        kycfileSize: kycFileSize,
        kycfileName: kycFile.name,
        kycsizeError: 'File size must be less than 5MB',
        kycfileSuccess: true,
        kycupload: false,
      });
    }
  };

  const Uploadfacade = () => {
    let facadeFile = document.getElementById('uploadFacadeDoc').files[0];
    const facadeFileSize = facadeFile.size / 1024 / 1024;
    if (facadeFileSize < 5) {
      setFacadeFileInfo({
        facadefileSize: facadeFileSize,
        facadefileName: facadeFile.name,
        facadesizeError: null,
        facadefileSuccess: false,
        facadeupload: false,
      });
      uploadFacade({facadeFile});
    } else {
      setFacadeFileInfo({
        facadefileSize: facadeFileSize,
        facadefileName: facadeFile.name,
        facadesizeError: 'File size must be less than 5MB',
        facadefileSuccess: true,
        facadeupload: false,
      });
    }
  };

  const onChangeHandler = (field, value) => {
    if (field === 'kycDocType') {
      sendEvarData(
        {
          prop54: `myPartner|signup|businessVerification|KYCDocumentType|${value}`,
        },
        true,
      );
    } else if (field === 'additionalDoc') {
      sendEvarData(
        {
          prop54: `myPartner|signup|businessVerification|AdditionalKYCDocumentType|${value}`,
        },
        true,
      );
    }

    const dataObj = {
      kycDocType,
      kycUploaded,
      facadeUploaded,
      additionalDoc,
    };
    dataObj[field] = value;
    setDocumentDetails(dataObj);
  };

  const clearKycUploadData = () => {
    sendEvarData(
      {
        prop54: 'myPartner|signup|businessVerification|removeDocument|KYC',
      },
      true,
    );

    setKycFileInfo({
      kycfileSize: null,
      kycfileName: null,
      kycsizeError: null,
      kycfileSuccess: true,
      kycupload: true,
    });
  };

  const clearFacadeUploadData = () => {
    sendEvarData(
      {
        prop54: 'myPartner|signup|businessVerification|removeDocument|facade',
      },
      true,
    );

    setFacadeFileInfo({
      facadefileSize: null,
      facadefileName: null,
      facadesizeError: null,
      facadefileSuccess: true,
      facadeupload: true,
    });
  };

  const resetKycUpload = () => {
    clearKycUploadData();
  };

  let kycUpload = (
    <S.KycLabelWrap>
      <UploadKycDoc change={showKycUpload} />
      <C.ErrorText>{errors?.['kycDoc']}</C.ErrorText>
    </S.KycLabelWrap>
  );
  if (!kycfileSuccess) {
    kycUpload = <UploadInfo filesize={kycfileSize} filename={kycfileName} reset={resetKycUpload} />;
  }

  if (kycUploaded && (!kycfileName || kycfileName === '')) {
    kycUpload = <UploadReset reset={resetKycUpload} close={showClose} />;
  }

  let facadeUpload = (
    <S.KycLabelWrap>
      <UploadFacadeDoc change={showFacadeUpload} />
      <C.ErrorText>{errors?.['facadeDoc']}</C.ErrorText>
    </S.KycLabelWrap>
  );

  if (!facadefileSuccess) {
    facadeUpload = (
      <UploadInfo
        filesize={facadefileSize}
        filename={facadefileName}
        reset={clearFacadeUploadData}
      />
    );
  }

  if (facadeUploaded && (!facadefileName || facadefileName === '')) {
    facadeUpload = <UploadReset reset={clearFacadeUploadData} close={showClose} />;
  }

  const cancelKycEvent = () => {
    setPopKycVisible(false);
    resetKycUpload();
    setFileUrl('');
  };

  const cancelFacadeEvent = () => {
    setPopFacadeVisible(false);
    clearFacadeUploadData();
    setFileUrl('');
  };

  const agreeKycEvent = () => {
    // sendEvarData({
    //   prop54: "myPartner|signup|businessVerification|docPreview|Supporting"
    // }, true)
    setPopKycVisible(false);
    uploadDocument();
    setFileUrl('');
  };

  const agreeFacadeEvent = () => {
    // sendEvarData({
    //   prop54: "myPartner|signup|businessVerification|docPreview|Facade"
    // }, true)
    setPopFacadeVisible(false);
    Uploadfacade();
    setFileUrl('');
  };

  const KYCDocTypeSelect = () => {
    return (
      <C.CommonSelect
        onChange={event => onChangeHandler('kycDocType', event.target.value)}
        value={kycDocType}
        hasError={errors?.['kycDocType'] ? true : false}
      >
        <option value="" disabled hidden>
          Select KYC Document Type
        </option>
        {kycDocList &&
          Object.keys(kycDocList).map(key => (
            <option key={key} value={key}>
              {kycDocList[key]}
            </option>
          ))}
      </C.CommonSelect>
    );
  };

  const AdditionalKYCDocTypeSelect = () => (
    <C.CommonSelect
      onChange={event => onChangeHandler('additionalDoc', event.target.value)}
      value={additionalDoc}
      hasError={errors?.['additionalDoc'] ? true : false}
    >
      <option value="" disabled hidden>
        Select Additonal KYC Document Type
      </option>
      {addDocList &&
        Object.keys(addDocList).map(key => (
          <option key={key} value={key}>
            {addDocList[key]}
          </option>
        ))}
    </C.CommonSelect>
  );

  const docUploaded = (event: React.FormEvent) => {
    event.preventDefault();
    let dataObj = {
      kycDocType,
      additionalDoc,
      kycDoc: kycUploaded,
      facadeDoc: facadeUploaded,
    };
    const hasError = validateFields(dataObj);
    if (!hasError) {
      submitDetails(dataObj);
    }
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Supporting Document Upload Click',
        },
      },
      'HOME',
    );
  };

  return (
    <C.PopContentMainWrap>
      <C.PopContentHeadWrap>
        <C.PopContentHeadText>Upload Documents</C.PopContentHeadText>
        <C.PopContentSubHeadText>We will use these to verify your account.</C.PopContentSubHeadText>
      </C.PopContentHeadWrap>
      <C.PopContentInnerWrap>
        <C.UserInfoForm onSubmit={docUploaded}>
          <S.SupportingDocumentMainWrap>
            <C.InputWrapper>
              <S.KycDocumentWrap>
                <C.CommonInputWrap>
                  <C.CommonLabel>Select KYC Document Type</C.CommonLabel>
                  <KYCDocTypeSelect />
                  <C.ErrorText>{errors?.['kycDocType']}</C.ErrorText>
                  <S.InfoNoteText>
                    Please upload KYC document against your agency name
                  </S.InfoNoteText>
                </C.CommonInputWrap>
              </S.KycDocumentWrap>
              <S.KycUploadDocumentWrap>{kycUpload}</S.KycUploadDocumentWrap>
            </C.InputWrapper>
            {(popKycVisible && (
              <C.PanCardUploadImageView>
                <C.PanCardUploadPreviewWrap>
                  <C.PanCardUploadHeadText>Upload Preview</C.PanCardUploadHeadText>
                  <C.PanCardUploadImgWrap>
                    <C.PanCardImgiewver>
                      <img src={fileUrl} alt="uploded pan" width="100%" height="auto" />
                    </C.PanCardImgiewver>
                  </C.PanCardUploadImgWrap>
                  <C.PanCardUploadBtnWrap>
                    <C.UploadAgainBtn onClick={cancelKycEvent}>Upload Again</C.UploadAgainBtn>
                    <C.ApproveBtn onClick={agreeKycEvent}>Upload</C.ApproveBtn>
                  </C.PanCardUploadBtnWrap>
                </C.PanCardUploadPreviewWrap>
              </C.PanCardUploadImageView>
            )) ||
              null}
          </S.SupportingDocumentMainWrap>
          {addDocList && (
            <S.SupportingDocumentMainWrap>
              <C.InputWrapper>
                <S.KycDocumentWrap>
                  <C.CommonInputWrap>
                    <C.CommonLabel>Select Supporting Document Type</C.CommonLabel>
                    <AdditionalKYCDocTypeSelect />
                    <C.ErrorText>{errors?.['additionalDoc']}</C.ErrorText>
                    <S.InfoNoteText>
                      Please upload supporting documents against your agency name
                    </S.InfoNoteText>
                  </C.CommonInputWrap>
                </S.KycDocumentWrap>
                <S.KycUploadDocumentWrap>{facadeUpload}</S.KycUploadDocumentWrap>
              </C.InputWrapper>
              {(popFacadeVisible && (
                <C.PanCardUploadImageView>
                  <C.PanCardUploadPreviewWrap>
                    <C.PanCardUploadHeadText>Upload Preview</C.PanCardUploadHeadText>
                    <C.PanCardUploadImgWrap>
                      <C.PanCardImgiewver>
                        <img src={fileUrl} alt="uploded pan" width="100%" height="auto" />
                      </C.PanCardImgiewver>
                    </C.PanCardUploadImgWrap>
                    <C.PanCardUploadBtnWrap>
                      <C.UploadAgainBtn onClick={cancelFacadeEvent}>Upload Again</C.UploadAgainBtn>
                      <C.ApproveBtn onClick={agreeFacadeEvent}>Upload</C.ApproveBtn>
                    </C.PanCardUploadBtnWrap>
                  </C.PanCardUploadPreviewWrap>
                </C.PanCardUploadImageView>
              )) ||
                null}
            </S.SupportingDocumentMainWrap>
          )}
          <C.ApiErrorText>
            {apiErrorMsg && apiErrorMsg.screen === 'details' ? apiErrorMsg.msg : ''}
          </C.ApiErrorText>
          <C.ButtonWrap>
            <C.ContinueButton type="submit" disabled={disableSubmitButton}>
              {setLoader ? <ButtonLoader loaderType="button" /> : 'Continue'}
            </C.ContinueButton>
          </C.ButtonWrap>
        </C.UserInfoForm>
      </C.PopContentInnerWrap>
    </C.PopContentMainWrap>
  );
};

export default SupportingDocument;
